HTMLElement.prototype.customDelegate = function customDelegate(eventName, elementSelector, handler) {
    this.addEventListener(eventName, (e) => {
        const element = e.target.closest(elementSelector);

        if (element) {
            handler.call(element, e, element);
        }
    }, false);
};
